import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { Router } from '@angular/router';
import { TokenJwtService } from '../services/tokenJwt.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private authenticationService: AuthenticationService,
        private tokenJwtService: TokenJwtService,
        private router: Router
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            if (request.url === environment.apiUrlV5 + 'api/tpsl-route/problem-reports' ||
                request.url === environment.apiUrlV5 + 'api/tpsl-route/session/refresh' ||
                request.url.indexOf(environment.apiUrl + 'api/v3/Mobiles/MobileGetMobileUser') === 0) {
                // Keep the report form and HTTP status available to the dialog.
                return throwError(err);
            }
            if (err.status === 401) {
                // auto logout if 401 response returned from api
                this.logout()
            }

            const error = err.error && err.error.message || err.statusText;
            return throwError(error);
        }))
    }

    logout(sessionExpired: boolean = true) {
        this.tokenJwtService.handleInvalidToken(sessionExpired);
    }

}
